class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this; // Corrected line to reference the FooterAccordion element itself
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));

    // Force open on desktop on load
    this.checkAndForceOpen();
    
    // Listen for window resize to force open on desktop
    window.addEventListener('resize', () => this.checkAndForceOpen());

    // Watch for attribute changes and force open on desktop
    this.observer = new MutationObserver(() => {
      if (window.innerWidth >= 750 && !this.detailsContainer.hasAttribute('open')) {
        this.detailsContainer.setAttribute('open', true);
      }
    });

    this.observer.observe(this.detailsContainer, {
      attributes: true,
      attributeFilter: ['open']
    });

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute('open', true);

      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    }
    else {
      if (this.dataset.open == undefined) this.detailsContainer.removeAttribute('open');
    }
  }

  checkAndForceOpen() {
    // Force open on desktop (750px and above)
    if (window.innerWidth >= 750) {
      this.detailsContainer.setAttribute('open', true);
    }
  }

  onSummaryClick(event) {
    // Disable accordion functionality on desktop (750px and above)
    if (window.innerWidth >= 750) {
      event.preventDefault();
      return;
    }
  }

  close() {
    if (window.innerWidth >= 750) return;
    this.detailsContainer.removeAttribute('open');
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

}

customElements.define('footer-accordion', FooterAccordion);
